export enum LinkOptimizationMode {
  ALL = 'ALL',         // Hide all link labels during drag
  RELATED = 'RELATED', // Hide only related/connected link labels (default)
  NONE = 'NONE'        // Don't hide any labels during drag
}